// extracted by mini-css-extract-plugin
export var screenLg = "992px";
export var screenXl = "1200px";
export var screenMd = "768px";
export var screenSm = "576px";
export var screenXlMax = "1199px";
export var screenLgMax = "991px";
export var screenMdMax = "767px";
export var screenSmMax = "575px";
export var MoreContent = "MoreContent-module--MoreContent--3ltzl";
export var MoreContent__wrapper = "MoreContent-module--MoreContent__wrapper--58cvm";
export var MoreContent__promoSlotContainer = "MoreContent-module--MoreContent__promoSlotContainer--KTvdL";
export var MoreContent__promoSlotAdvert = "MoreContent-module--MoreContent__promoSlotAdvert--20t2y";
export var MoreContent__promoSlotContainerPreview = "MoreContent-module--MoreContent__promoSlotContainer--preview--4IZy9";
export var MoreContent__promoSlotContainerPreviewmask = "MoreContent-module--MoreContent__promoSlotContainer--previewmask--1Xwcw";
export var MoreContent__promoSlot = "MoreContent-module--MoreContent__promoSlot--2-EWc";
export var MoreContent__promoSlot__textWrap = "MoreContent-module--MoreContent__promoSlot__textWrap--dIaI8";
export var MoreContent__promoSlot__imageContainer = "MoreContent-module--MoreContent__promoSlot__imageContainer--2Ut6X";
export var MoreContent__promoSlot__header = "MoreContent-module--MoreContent__promoSlot__header--1GI8j";
export var MoreContent__promoSlot__title = "MoreContent-module--MoreContent__promoSlot__title--2zFZF";
export var MoreContent__promoSlot__cta = "MoreContent-module--MoreContent__promoSlot__cta--ppVLD";
export var MoreContent__loadMore = "MoreContent-module--MoreContent__loadMore--2Q9Tr";